
export default function ViewButton2() {
    return (
        <i className="icon view_icon"/>
    )
}